var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh_light",
    transform: "translate(-0.404)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 25,
    height: 25,
    transform: "translate(0.404)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_synchronize",
    d: "M12.5,5A7.505,7.505,0,0,0,5,12.5a.375.375,0,1,0,.75,0A6.748,6.748,0,0,1,18.109,8.75H15.5a.375.375,0,1,0,0,.75h3.75V5.75a.375.375,0,1,0-.75,0V8A7.49,7.49,0,0,0,12.5,5Zm7.119,7.119a.377.377,0,0,0-.369.381A6.748,6.748,0,0,1,6.891,16.25H9.5a.376.376,0,0,0,.33-.185A.376.376,0,0,0,9.5,15.5H6.292a.4.4,0,0,0-.145,0h-.4v3.75a.375.375,0,1,0,.75,0V16.994A7.5,7.5,0,0,0,20,12.5a.375.375,0,0,0-.381-.381Z",
    transform: "translate(0.289)",
    fill: "#374955"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshLight);
export default __webpack_public_path__ + "static/media/refresh_light.35d1a57091d31b5c8690dfec6d01e317.svg";
export { ForwardRef as ReactComponent };